import React, { useState, useEffect, useRef } from "react";
import "./index.less";

interface PageScrollListProps {
  renderItem: (order: any) => React.ReactNode;
  fetchOrders: (page: number) => Promise<any[]>;
  total: number | null;
}

const PageScrollList = (props: PageScrollListProps) => {
  const { renderItem, fetchOrders, total } = props;
  const [orders, setOrders] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const loading = useRef(false);
  const ListRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const loadOrders = async () => {
      loading.current = true;
      const newOrders = await fetchOrders(page);
      loading.current = false;
      if(newOrders && newOrders.length > 0) {
        setOrders(orders => [...orders, ...newOrders]);
      }
    };
    loadOrders();
  }, [page]);

  const handleScroll = () => {
    console.log('handleScroll')
    const DOM = ListRef.current;
    if (!DOM || loading.current || total === orders.length) return;
    console.log(DOM.scrollTop, DOM.clientHeight, DOM.scrollHeight);
    if (DOM.scrollTop + 10 >= DOM.scrollHeight - DOM.clientHeight) {
      setPage(page => page + 1);
    }
  };

  return (
    <div
      ref={ListRef}
      onScroll={handleScroll}
      style={{ height: "100%", width: "100%", overflow: "scroll" }}
    >
      <div>
        {orders.map((item, index) => (
          renderItem(item)
        ))}
      </div>
      {loading.current && <div className="page-scroll-list-tips">加载中</div>}
      {!loading.current && total === orders.length && (
        <div className="page-scroll-list-tips">没有更多了</div>
      )}
    </div>
  );
};

export default PageScrollList;
